import { useCallback } from 'react';

import { FilterMeta } from 'proto/Search/FilterMeta';

export enum MetaValue {
    NoResult,
    NoCount,
    NoPotential,
    Never,
}

export const useDisabledStatus = (disableWhen: MetaValue) => {
    const getDisabledStatus = useCallback(
        (meta: FilterMeta) => {
            switch (disableWhen) {
                case MetaValue.NoResult:
                    return meta.hasCount && meta.count === 0;
                case MetaValue.NoCount:
                    return !meta.hasCount;
                case MetaValue.NoPotential:
                    return !meta.isPotential;
                case MetaValue.Never:
                    return false;
                default:
                    return false;
            }
        },
        [disableWhen]
    );
    return getDisabledStatus;
};
